module.exports = __webpack_public_path__ + "img/glitter_12.d5f13eab.jpg";